import React from "react";

const KeyValue = ({ label, className = "", value, oneLine = true }) => {
  const renderValue = () => {
    // If value is null or undefined
    if (value === null || value === undefined) {
      return "-";
    }

    // If value is an array
    if (Array.isArray(value)) {
      return value.map((item, index) => (
        <span key={index} className="block">
          {typeof item === "object" ? JSON.stringify(item) : item}
        </span>
      ));
    }

    // If value is a React element (like a modal)
    if (React.isValidElement(value)) {
      return value; // Render the React element directly
    }

    // If value is an object but not a React element
    if (typeof value === "object") {
      return JSON.stringify(value);
    }

    // Default case: string, number, boolean, etc.
    return value;
  };
  return (
    <div className={`body-two flex  ${oneLine ? "gap-1" : "flex-col gap-0.5"}`}>
      {label && (
        <span className={`font-semibold text-nowrap line-clamp-1 ${className}`}>
          {label} :
        </span>
      )}
      <span>{renderValue()}</span>
    </div>
  );
};

export default KeyValue;
